import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=44567e85&scoped=true&"
import script from "./TopHeader.vue?vue&type=script&lang=js&"
export * from "./TopHeader.vue?vue&type=script&lang=js&"
import style0 from "./TopHeader.vue?vue&type=style&index=0&id=44567e85&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44567e85",
  null
  
)

export default component.exports